import * as Yup from 'yup';

import {getLanguageScope, createMessage, C} from '../../../../helpers'

const _i18n = getLanguageScope('validation');
const _s_i18n = getLanguageScope('check_cashing_validation');

// s_customer_first_name, s_customer_middle_name, s_customer_last_name, s_customer_cell_phone,
//   s_customer_home_phone, s_customer_address1, s_customer_address2, s_customer_address_city, s_customer_address_state,
//   s_customer_address_zip, s_customer_gender, s_customer_dob, s_customer_email, s_customer_ssn, s_customer_id_type,
//   s_customer_id_number, s_customer_id_issuer, s_customer_id_expiration_date

const createCustomerValidationSchema = () => Yup.object().shape({
  s_customer_first_name: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  s_customer_middle_name: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20})),
  s_customer_last_name: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  s_customer_cell_phone: Yup.string()
    .min(11, createMessage(_i18n('min'), {count: 11}))
    .required(_i18n('required')),
  s_customer_home_phone: Yup.string()
    .max(20, createMessage(_i18n('max'), {count: 20})),
  s_customer_address1: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(50, createMessage(_i18n('max'), {count: 50}))
    .required(_i18n('required')),
  s_customer_address2: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(50, createMessage(_i18n('max'), {count: 50})),
  s_customer_address_city: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(25, createMessage(_i18n('max'), {count: 25}))
    .required(_i18n('required')),
  s_customer_address_state: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(2, createMessage(_i18n('max'), {count: 2}))
    .required(_i18n('required')),
  s_customer_address_zip: Yup.string()
    .min(3, createMessage(_i18n('min'), {count: 3}))
    .max(10, createMessage(_i18n('max'), {count: 10}))
    .required(_i18n('required')),
  s_customer_dob: Yup.string(),
  s_customer_email: Yup.string()
    .email(_i18n('email')),
  s_customer_ssn: Yup.string()
    .min(9, createMessage(_i18n('min'), {count: 9}))
    .max(9, createMessage(_i18n('max'), {count: 9}))
    .required(_i18n('required')),
  s_customer_id_type: Yup.string()
    .required(_i18n('required'))
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  s_customer_id_number: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  s_customer_id_issuer: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(50, createMessage(_i18n('max'), {count: 50}))
    .required(_i18n('required')),
  s_customer_id_expiration_date: Yup.string()
    .required(_i18n('required')),
});

const createCheckValidatorSchema = () => Yup.object().shape({
  customer_id: Yup.number()
    .required(_s_i18n('customer_id_required')),
  s_customer_check_path_front: Yup.string()
    .matches(/\/assets\/[^/]+$/, {
      message: _s_i18n('check_image_front_incorrect'),
      excludeEmptyString: true
    })
    .required(_s_i18n('check_image_front_required')),
  s_customer_check_path_back: Yup.string()
    .matches(/\/assets\/[^/]+$/, {
      message: _s_i18n('check_image_back_incorrect'),
      excludeEmptyString: true
    })
    .required(_s_i18n('check_image_back_required')),
  s_customer_id: Yup.string()
    .required(_s_i18n('s_customer_id_required')),
  check_maker_aba_number: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  check_maker_account_number: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  check_maker_name: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(40, createMessage(_i18n('max'), {count: 40}))
    .required(_i18n('required')),
  check_maker_address: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(40, createMessage(_i18n('max'), {count: 40}))
    .required(_i18n('required')),
  check_maker_city: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(40, createMessage(_i18n('max'), {count: 40}))
    .required(_i18n('required')),
  check_maker_state: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(2, createMessage(_i18n('max'), {count: 2}))
    .required(_i18n('required')),
  check_maker_zip: Yup.string()
    .min(3, createMessage(_i18n('min'), {count: 3}))
    .max(10, createMessage(_i18n('max'), {count: 10}))
    .required(_i18n('required')),
  display_amount: Yup.number()
    .min(1, createMessage(_s_i18n('min_amount'), {amount: C(1, '$')}))
    .max(1000, createMessage(_s_i18n('max_amount'), {amount: C(1000, '$')}))
    .required(_i18n('required')),
  check_number: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(20, createMessage(_i18n('max'), {count: 20}))
    .required(_i18n('required')),
  check_date: Yup.string()
    .matches(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/, {
      message: _s_i18n('check_date_incorrect'),
      excludeEmptyString: true
    })
    .required(_i18n('required')),
  check_raw_micr: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(150, createMessage(_i18n('max'), {count: 150}))
    .required(_i18n('required')),
  check_payee_name: Yup.string()
    .min(2, createMessage(_i18n('min'), {count: 2}))
    .max(40, createMessage(_i18n('max'), {count: 40}))
    .required(_i18n('required')),
  updating_amounts: Yup.boolean().oneOf([false], _s_i18n('updating_amounts')),
});

export {
  createCustomerValidationSchema,
  createCheckValidatorSchema
}


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/models/formValidation.js